import { render, staticRenderFns } from "./interactiveanswerreply.vue?vue&type=template&id=1c9bc718&scoped=true&"
import script from "./interactiveanswerreply.vue?vue&type=script&lang=js&"
export * from "./interactiveanswerreply.vue?vue&type=script&lang=js&"
import style0 from "./interactiveanswerreply.vue?vue&type=style&index=0&id=1c9bc718&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9bc718",
  null
  
)

export default component.exports